module.exports = __webpack_public_path__ + "leftbg.765358abe4890412074c.jpg";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/img/leftbg.jpg
// module id = ../../../../../src/assets/img/leftbg.jpg
// module chunks = styles